import { MDSText, ValidationProps, WarningIcon } from '@midwest/web/base';
import styled from 'styled-components';

export const TextAreaContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const TextAreaAndInvalidIcon = styled.div`
  display: flex;
  flex-direction: row;
`;

export const TextAreaContainerText = styled(MDSText.BodyRegSm)`
  color: ${(p) => p.theme.midwestColors.textPrimary};
  width: 100%;
`;

export const TextArea = styled.textarea<ValidationProps>`
  display: flex;
  border: none;
  resize: none;
  cursor: ${(p) => (p.$disabled ? 'not-allowed' : p.$readOnly ? 'text' : '')};
  width: 100%;
  padding: 12px;

  color: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  font-family: inherit;

  background: ${(p) =>
    p.$disabled
      ? `${p.theme.midwestColors.neutralLightMedium}`
      : p.$readOnly
        ? p.theme.midwestColors.textSecondaryDarkBG
        : p.theme.midwestColors.backgroundPrimary};

  &:focus,
  &:focus-visible {
    border: none;
    outline: none;
  }

  ::placeholder {
    opacity: ${(p) => (p.$readOnly ? 0 : 1)};
    color: ${(p) =>
      p.$disabled
        ? p.theme.midwestColors.textDisabled
        : p.theme.midwestColors.componentFormColorTextPlaceholder};
    font-size: 14px;
    font-weight: 400;
  }

  @media not (prefers-reduced-motion) {
    transition: background-color 5000s ease-in-out 0s;
  }
  background-clip: text;
`;

export const TextAreaInvalidIcon = styled((props) => (
  <WarningIcon {...props} />
))`
  fill: ${(p) => p.theme.midwestColors.sentimentNegativeStrong};
  height: 18px;
  width: 18px;
  margin-top: 13px;
  margin-right: 12px;
`;

export const TextAreaError = styled(MDSText.BodyMediumSm)`
  color: ${(p) => p.theme.midwestColors.sentimentNegativeStrong};
`;

export const ValueContainer = styled(MDSText.BodyRegSm)`
  display: flex;
  justify-content: flex-end;
  color: ${(p) => p.theme.midwestColors.componentFormColorTextPlaceholder};
  padding: ${(p) => p.theme.spacing.sm};
  overflow: auto;
  cursor: inherit;
`;
